import { render, staticRenderFns } from "./wt-box.vue?vue&type=template&id=e0c12486&"
import script from "./wt-box.vue?vue&type=script&lang=js&"
export * from "./wt-box.vue?vue&type=script&lang=js&"
import style0 from "./wt-box.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports